import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View } from '../View'

const OptionWrapper = styled.div`
  padding: var(--spacing-2);
  border: 1px solid var(--color-neutral-90);
  border-radius: var(--border-radius-1);
  ${({ modalMode, experimentOn }) =>
    experimentOn ? `width: 100%;` : modalMode ? `width: 100%;` : `width: 354px`}
  height: ${({ experimentOn }) => (experimentOn ? 'auto' : '113px')};
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  :hover {
    background-color: var(--color-neutral-80);
  }
`

const IconWrapper = styled.div`
  margin-right: var(--spacing-1);
  ${({ disabled }) =>
    disabled && '-webkit-filter: grayscale(0.9); filter: grayscale(0.9); opacity: 0.5;'}
`

const TextWrapper = styled.div`
  margin-left: var(--spacing-1);
  margin-right: var(--spacing-1);
  flex: 1;
`

export const OptionRectangle = ({
  title,
  icon,
  actionIcon,
  onClick,
  disabled = true,
  children,
  modalMode,
  experimentOn,
}) => {
  const onRectangleClick = () => {
    if (!disabled && typeof onClick === 'function') {
      onClick()
    }
  }
  return (
    <OptionWrapper
      disabled={disabled}
      onClick={onRectangleClick}
      modalMode={modalMode}
      experimentOn={experimentOn}
    >
      <IconWrapper disabled={disabled}>{icon}</IconWrapper>
      <TextWrapper>
        <span
          className={`typo-subtitle-medium block ${experimentOn ? 'font-bold' : ''} ${
            disabled ? 'text-neutral-100' : experimentOn ? 'text-neutral-130' : 'text-neutral-120'
          }`}
        >
          {title}
        </span>
        <span
          className={`typo-body-small mt-0-5 ${
            disabled ? 'text-neutral-100' : experimentOn ? 'text-neutral-130' : 'text-neutral-110'
          }`}
        >
          {children}
        </span>
      </TextWrapper>
      <View>{actionIcon}</View>
    </OptionWrapper>
  )
}

OptionRectangle.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
  actionIcon: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  modalMode: PropTypes.bool,
  experimentOn: PropTypes.bool,
}
